import * as React from "react";
import { createStyles, WithStyles, withStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";
import { FooterNavigation } from "../modules/navigation";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      borderTop: "1px solid #DDE9E0",
      height: 50,
      width: "100%",
      paddingLeft: 32,
      paddingRight: 32,
      backgroundColor: "#EDEDED",
      display: "flex",
      alignItems: "center",
      flex: "none",
      justifyContent: "space-between",
      position: "fixed",
      bottom: "0",
      zIndex: 1,
    },
    navigation: {},
    link: {
      color: "#333333",
      opacity: 0.8,
      fontSize: "12px",
      lineHeight: "14px",
      fontWeight: "normal",
    },
    smrtanl: {
      fontSize: "12px",
      lineHeight: "14px",
      color: "#333333",
      opacity: 0.5,
    },
  });

type Props = WithStyles<typeof styles>;

class Footer extends React.Component<Props> {
  render = () => {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <FooterNavigation parentClasses={classes} />
        <span className={classes.smrtanl}>Powered by Smart Analytics</span>
      </div>
    );
  };
}

export default withStyles(styles)(Footer);
